import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { TranslationRow, TranslationTable } from "../Translationtableparts";

function TableBodyRowContent({
  categoryTranslation,
  deletedList,
}: {
  categoryTranslation: CategoryTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deleteCategoryTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`category-translations/${id}`, token);
  });

  const removeCategoryTranslation = () => {
    deleteCategoryTranslation.mutate(categoryTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <TranslationRow
      id={categoryTranslation.id}
      deletedList={deletedList}
      sourceTitle={categoryTranslation.category?.label}
      translation={categoryTranslation?.label}
      lang={categoryTranslation?.lang}
      editTo={`/category-translations/update/${categoryTranslation.id}`}
      onDelete={removeCategoryTranslation}
      isDeleting={deleteCategoryTranslation.isLoading}
    />
  );
}

interface TableProps {
  categoryTranslations: CategoryTranslation[];
  categoryTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function CategoryTranslationsTable({
  categoryTranslations,
  categoryTranslationsToBeDeleted,
}: TableProps) {
  return (
    <TranslationTable sourceLabel="Catégorie">
      {categoryTranslations?.map((categoryTranslation) => (
        <TableBodyRowContent
          categoryTranslation={categoryTranslation}
          key={categoryTranslation?.id}
          deletedList={categoryTranslationsToBeDeleted}
        />
      ))}
    </TranslationTable>
  );
}
